export enum ApiResponseType {
  BLOB = 'blob',
}
